import {
    GET_ALL_WORKSPACES_REQUEST,
    GET_ALL_WORKSPACES_SUCCESS,
    GET_ALL_WORKSPACES_FAIL,
    GET_ALL_WORKSPACES_RESET,
    GET_CURRENT_WORKSPACE_REQUEST,
    GET_CURRENT_WORKSPACE_SUCCESS,
    GET_CURRENT_WORKSPACE_FAIL,
    GET_CURRENT_WORKSPACE_RESET,
    CREATE_WORKSPACE_REQUEST,
    CREATE_WORKSPACE_SUCCESS,
    CREATE_WORKSPACE_FAIL,
    CREATE_WORKSPACE_RESET,
    CREATE_WORKSPACE_INITIAL_REQUEST,
    CREATE_WORKSPACE_INITIAL_SUCCESS,
    CREATE_WORKSPACE_INITIAL_FAIL,
    CREATE_WORKSPACE_INITIAL_RESET,
    EDIT_WORKSPACE_REQUEST,
    EDIT_WORKSPACE_SUCCESS,
    EDIT_WORKSPACE_FAIL,
    EDIT_WORKSPACE_RESET,
} from '../constants/workspaceConstants'

export const allWorkspacesReducer = (state = { }, action) => {
    switch (action.type) {
        case GET_ALL_WORKSPACES_REQUEST:
            return { loading: true }
        case GET_ALL_WORKSPACES_SUCCESS:
            return { loading: false, workspaceDetails: action.payload }
        case GET_ALL_WORKSPACES_FAIL:
            return { loading: false, error: action.payload }
        case GET_ALL_WORKSPACES_RESET:
            return { }
        default:
            return state
    }
}

export const currentWorkSpaceReducer = (state = { }, action) => {
    switch (action.type) {
        case GET_CURRENT_WORKSPACE_REQUEST:
            return { loading: true, }
        case GET_CURRENT_WORKSPACE_SUCCESS:
            return { loading: false, currentWorkspaceDetails: action.payload }
        case GET_CURRENT_WORKSPACE_FAIL:
            return { loading: false, error: action.payload }
        case GET_CURRENT_WORKSPACE_RESET:
            return { }
        default:
            return state
    }
}

export const workspaceCreateInitialReducer = (state = { }, action) => {
    switch (action.type) {
        case CREATE_WORKSPACE_INITIAL_REQUEST:
            return { loading: true, }
        case CREATE_WORKSPACE_INITIAL_SUCCESS:
            return { loading: false, workspaceData: action.payload }
        case CREATE_WORKSPACE_INITIAL_FAIL:
            return { loading: false, error: action.payload }
        case CREATE_WORKSPACE_INITIAL_RESET:
            return { }
        default:
            return state
    }
}

export const workspaceCreateReducer = (state = { }, action) => {
    switch (action.type) {
        case CREATE_WORKSPACE_REQUEST:
            return { loading: true, }
        case CREATE_WORKSPACE_SUCCESS:
            return { loading: false, workspaceData: action.payload, success: true }
        case CREATE_WORKSPACE_FAIL:
            return { loading: false, error: action.payload }
        case CREATE_WORKSPACE_RESET:
            return { }
        default:
            return state
    }
}

export const workspaceEditReducer = (state = { }, action) => {
    switch (action.type) {
        case EDIT_WORKSPACE_REQUEST:
            return { loading: true, }
        case EDIT_WORKSPACE_SUCCESS:
            return { loading: false, workspaceData: action.payload, success: true }
        case EDIT_WORKSPACE_FAIL:
            return { loading: false, error: action.payload }
        case EDIT_WORKSPACE_RESET:
            return { }
        default:
            return state
    }
}